import createScriptElement from "./createScriptElement";
import initiateGoogleAds from "../initiateGoogleAds";
import handleRefetchAdvert from "./handleRefetchAdvert";

const loadGoogleScript = (config, handleGoogleLoad) => {
  let taggingScript;
  const { scriptSrc, scriptId } = config;

  if (!document.getElementById(scriptId)) {
    taggingScript = createScriptElement(scriptSrc, scriptId);

    taggingScript.onload = () => {
      initiateGoogleAds(config, handleGoogleLoad);
    };

    document.head.appendChild(taggingScript);
  } else {
    handleRefetchAdvert(config);
  }
};

export default loadGoogleScript;
